import { InsertStatus } from '../types/mold';

export const getInsertStatusLabel = (status: InsertStatus) => {
    switch (status) {
        case 'active':
            return {
                label: 'พร้อมใช้งาน',
                bgColor: 'bg-green-100',
                textColor: 'text-green-800',
            };
        case 'in_used':
            return {
                label: 'กำลังใช้งาน',
                bgColor: 'bg-yellow-100',
                textColor: 'text-yellow-800',
            };
        case 'cancelled':
            return {
                label: 'ยกเลิก',
                bgColor: 'bg-red-100',
                textColor: 'text-red-800',
            };
        default:
            return {
                label: 'ไม่ทราบสถานะ',
                bgColor: 'bg-gray-100',
                textColor: 'text-gray-800',
            };
    }
};
